import { useAuth0 } from "@auth0/auth0-react";
import { Button, Typography } from "@mui/material";

export const DeactivatedUserError = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 p-4 text-center">
      <div className="w-3/5 gap-2 flex flex-col">
        <Typography
          variant="h4"
          component="h1"
          className="font-bold"
          textAlign="left"
        >
          Oopsie!
          <br />
          You don't have access to any organizations.
        </Typography>
        <Typography variant="body1" className="w-full" textAlign="left">
          Please contact your administrator to get access to one.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogout}
          className="w-fit mt-4"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
